import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { UnstyledLink } from '../../../typography/UnstyledLink'
import { Link } from '../../../typography/Link'
import { Tag } from '../../../tag'
import { DepartmentSection } from './DepartmentSection'
import * as styles from './FeaturedBoard.module.scss'

const FeaturedBoard = ({ jobs }) => {
  // Need to add the logic to break the jobs into the appropriate departments
  const filteredJobs = jobs
  filteredJobs.length = 5

  const featuredJobs = filteredJobs.reduce((finalArray, item) => {
    const jobsItem = {
      absoluteURL: item.absolute_url,
      role: item.title,
      location: item.location,
      roleType: item.employment_type,
      updated_at: new Date(item.updated_at).getTime(),
    }
    // This logic sorts into departments. Will leave here in case we choose to reimplement
    // const jobsList = finalArray.find(i => i.department === item.metadata[2].value)
    // if (jobsList) {
    //   // jobsList.jobs.push(jobsItem)
    //   finalArray.push(jobsItem)
    // } else {
    finalArray.push({
      department: item.department,
      updated_at: new Date(item.updated_at).getTime(),
      jobs: [jobsItem],
    })
    // }
    return finalArray
  }, [])
  const updatedDateSort = (a, b) => b.updated_at - a.updated_at
  featuredJobs.sort(updatedDateSort)
  const featuredLength = featuredJobs.length
  // Get the departments that are present in the listed jobs
  return (
    <div className={styles.jobBoard}>
      <div className={styles.featuredJobs}>
        <p>FEATURED JOBS</p>
      </div>
      <table className={styles.jobBoardContainer}>
        <div className={styles.departmentRow}>
          {featuredJobs.map((job, i) => {
            return (
              <DepartmentSection
                department={job.department}
                jobs={job}
                i={i}
                length={featuredLength}
              />
            )
          })}
        </div>
      </table>
    </div>
  )
}

export { FeaturedBoard }
export default FeaturedBoard
